import ar from './ar.json'
import de from './de.json'
import en from './en.json'
import fa from './fa.json'
import ja from './ja.json'
import tr from './tr.json'
import es from './es.json'

export const languages = {
  'العربية': ar,
  'Deutsch': de,
  'English': en,
  'فارسی': fa,
  '日本語': ja,
  'Türkçe': tr,
  'español': es,
}

export const langShortName = name => {
  switch(name) {
    case 'العربية': return 'ar'; break
    case 'Deutsch': return 'de'; break
    case 'فارسی': return 'fa'; break
    case '日本語': return 'ja'; break
    case 'Türkçe': return 'tr'; break
    case 'español': return 'es'; break
  }
  return 'en'
}

let defaultLang = 'English'
if (!localStorage.getItem('lang')) {
  const langCode = (navigator.language || navigator.userLanguage) || ''
  switch (true) {
    case langCode.startsWith('ar-') || langCode === 'ar': defaultLang = 'العربية'; break
    case langCode.startsWith('de-') || langCode === 'de': defaultLang = 'Deutsch'; break
    case langCode.startsWith('fa-') || langCode === 'fa': defaultLang = 'فارسی'; break
    case langCode.startsWith('ja-') || langCode === 'ja': defaultLang = '日本語'; break
    case langCode.startsWith('tr-') || langCode === 'tr': defaultLang = 'Türkçe'; break
    case langCode.startsWith('es-') || langCode === 'es': defaultLang = 'español'; break
    case langCode === 'en-US' || langCode === 'en': {
      const timezone = Intl?.DateTimeFormat?.().resolvedOptions?.()?.timeZone
      if (timezone) {
        const capitalLangs = {
          ar: ['Riyadh', 'Dubai', 'Kuwait', 'Qatar', 'Bahrain', 'Muscat', 'Aden', 'Baghdad', 'Amman', 'Beirut', 'Damascus', 'Hebron', 'Gaza'],
          de: ['Berlin', 'Vienna', 'Zurich', 'Vaduz', 'Luxembourg'],
          fa: ['Tehran', 'Kabul'],
          ja: ['Tokyo'],
          tr: ['Istanbul', 'Nicosia'],
          es: ['Mexico_City', 'Buenos_Aires', 'Bogota', 'Santiago', 'Easter', 'Lima', 'Caracas', 'Havana', 'Montevideo', 'Asuncion', 'La_Paz', 'Guayaquil', 'Galapagos', 'Santo_Domingo', 'Guatemala', 'Tegucigalpa', 'El_Salvador', 'Managua', 'Panama', 'Puerto_Rico', 'Costa_Rica']
        }
        switch (true) {
          case !!capitalLangs.ar.find(capital => timezone.endsWith(capital)): defaultLang = 'العربية'; break
          case !!capitalLangs.de.find(capital => timezone.endsWith(capital)): defaultLang = 'Deutsch'; break
          case !!capitalLangs.fa.find(capital => timezone.endsWith(capital)): defaultLang = 'فارسی'; break
          case !!capitalLangs.ja.find(capital => timezone.endsWith(capital)): defaultLang = '日本語'; break
          case !!capitalLangs.tr.find(capital => timezone.endsWith(capital)): defaultLang = 'Türkçe'; break
          case !!capitalLangs.es.find(capital => timezone.endsWith(capital)): defaultLang = 'español'; break
        }
      }
    }
    break
  }
  localStorage.setItem('lang', defaultLang)
}

export const defaultLocale = defaultLang